<div class="workspace-shell">
  <div class="mobile-shade" *ngIf="mobile()" (click)="mobile.set(false)"></div>
  <aside class="sidebar" [class.open]="mobile()" aria-label="주 메뉴">
    <button
      class="icon-button nav-close"
      aria-label="메뉴 닫기"
      (click)="mobile.set(false)"
    >
      <wiz-icon name="close"></wiz-icon>
    </button>
    <a routerLink="/dashboard" class="brand"
      ><img
        *ngIf="logo()"
        [src]="logo()"
        alt="워크스페이스 로고"
        width="33"
        height="33"
      /><img
        *ngIf="!logo()"
        src="/assets/brand/symbol.svg"
        alt="Docker Infra 심볼"
        width="33"
        height="33"
      /><span>{{ title() }}<small>인프라 관리 콘솔</small></span></a
    >
    <nav class="sidebar-scroll">
      <ng-container *ngFor="let item of nav; let first=first"
        ><div *ngIf="item.group" class="nav-group-label" [class.first]="first">
          {{ item.group }}
        </div>
        <a
          class="nav-item"
          [routerLink]="'/' + item.id"
          [class.active]="section() === item.id"
          [attr.aria-current]="section() === item.id ? 'page' : null"
          ><wiz-icon [name]="item.icon"></wiz-icon><span>{{ item.title }}</span
          ><span class="active-mark" *ngIf="section() === item.id"></span></a
      ></ng-container>
    </nav>
    <div class="sidebar-bottom">
      <button class="agent-launch" (click)="openAgent()">
        <wiz-icon name="spark"></wiz-icon
        ><span
          ><strong>인프라 Agent</strong
          ><small>운영에 도움이 필요할 때</small></span
        ><wiz-icon class="arrow" name="chevron"></wiz-icon>
      </button>
      <div class="sidebar-footer">
        <span class="user-avatar">AD</span
        ><span class="user-label">관리자<small>워크스페이스 관리자</small></span
        ><button
          class="icon-button"
          (click)="logout()"
          aria-label="로그아웃"
          title="로그아웃"
        >
          <wiz-icon name="logout"></wiz-icon>
        </button>
      </div>
    </div>
  </aside>
  <div class="workspace-content">
    <header class="topbar">
      <div class="breadcrumbs">
        <button
          class="icon-button mobile-menu"
          aria-label="메뉴 열기"
          (click)="mobile.set(true)"
        >
          <wiz-icon name="menu"></wiz-icon></button
        ><a class="workspace-list-link" [routerLink]="'/' + section()" [attr.aria-label]="current() + ' 목록으로'">워크스페이스</a><wiz-icon name="chevron"></wiz-icon
        ><h1>{{ contextSnapshot()['title'] || current() }}</h1>
      </div>
      <div class="topbar-actions">
        <button *ngIf="pageRefresh.current() as refresh" type="button"
          class="icon-button page-refresh" aria-label="새로고침" title="새로고침"
          [disabled]="refresh.loading()" [attr.aria-busy]="refresh.loading()" (click)="refresh.run()">
          <wiz-icon name="refresh"></wiz-icon>
        </button>
        <span class="topbar-status"
          ><i class="status-dot"></i
          ><span *ngIf="expiry()">{{ expiry() }}까지</span></span
        ><button
          class="text-link"
          (click)="extend()"
          [disabled]="sessionBusy()"
          title="세션 연장"
        >
          <wiz-icon name="chevron"></wiz-icon>세션 연장</button
        ><span class="topbar-divider"></span
        ><button
          class="icon-button"
          (click)="openAgent()"
          aria-label="인프라 Agent 열기"
        >
          <wiz-icon name="spark"></wiz-icon></button
        >
      </div>
    </header>
    <div class="notice error" *ngIf="error()" role="alert">
      {{ error() }}<button
        class="icon-button"
        aria-label="오류 닫기"
        (click)="error.set('')"
      >
        <wiz-icon name="close"></wiz-icon>
      </button>
    </div>
    <main *ngIf="ready()"><router-outlet></router-outlet></main>
    <div class="loading-state" *ngIf="!ready()">
      <span class="spinner"></span>워크스페이스를 불러오는 중입니다.
    </div>
    <footer class="page-footer" *ngIf="ready()">
      <span>Docker Infra · 인프라 운영을 더 명료하게.</span
      ><span>한국어 · 대한민국 표준시</span>
    </footer>
  </div>
  <aside
    class="agent-drawer"
    *ngIf="agentOpen()"
    aria-label="인프라 Agent"
    [style.width.px]="agentPanelWidth()"
    [class.resizing]="agentResizing()"
  >
    <div
      class="agent-resize-handle"
      role="separator"
      tabindex="0"
      aria-label="Agent 패널 너비 조절"
      aria-orientation="vertical"
      [attr.aria-valuemin]="agentMinWidth()"
      [attr.aria-valuemax]="viewportWidth()"
      [attr.aria-valuenow]="agentPanelWidth()"
      title="드래그 또는 방향키로 너비 조절"
      (pointerdown)="startAgentResize($event)"
      (pointermove)="moveAgentResize($event)"
      (pointerup)="stopAgentResize()"
      (pointercancel)="stopAgentResize()"
      (lostpointercapture)="stopAgentResize()"
      (keydown)="agentResizeKeydown($event)"
    ></div>
    <div class="agent-header">
      <div class="agent-title">
        <wiz-icon name="spark"></wiz-icon>인프라 Agent
      </div>
      <div class="tabs agent-tabs">
        <button [class.active]="agentTab==='chat'" (click)="showChat()">
          <wiz-icon name="inbox"></wiz-icon><span>대화</span>
        </button>
        <button [class.active]="agentTab==='history'" (click)="history()">
          <wiz-icon name="history"></wiz-icon><span>이전 대화</span>
        </button>
      </div>
      <div class="agent-header-actions">
        <button
          class="icon-button"
          type="button"
          aria-label="Agent 새로고침"
          title="Agent 새로고침"
          [disabled]="agentLoading()"
          (click)="refreshAgent()"
        ><wiz-icon name="refresh"></wiz-icon></button>
        <button
          class="icon-button"
          type="button"
          aria-label="Agent 닫기"
          title="Agent 닫기"
          (click)="closeAgent()"
        ><wiz-icon name="close"></wiz-icon></button>
      </div>
    </div>
    <div class="agent-progress" *ngIf="agentRunning()" [attr.aria-busy]="!pendingInteraction()">
      <wiz-icon *ngIf="pendingInteraction()" name="help"></wiz-icon>
      <span class="spinner" *ngIf="!pendingInteraction()" aria-hidden="true"></span>
      <span role="status">{{ pendingInteraction() ? '사용자 응답 대기' : 'Agent 진행 중' }}<small>{{ activeJob()?.['progress'] || '질문을 처리하고 있습니다.' }}</small></span>
      <time aria-label="현재 걸린 시간">{{ elapsed(activeJob()!) }}</time>
    </div>
    <div class="agent-content">
      <div class="notice error" role="alert" *ngIf="agentError()">{{ agentError() }}</div>
      <div class="loading-state" *ngIf="agentLoading()"><span class="spinner"></span>불러오는 중</div>
      <ng-container *ngIf="agentTab==='chat'">
        <div class="agent-welcome" *ngIf="!activeJob()">
          <span class="surface-icon"><wiz-icon name="spark"></wiz-icon></span>
          <h3>무엇을 도와드릴까요?</h3>
          <p>현재 화면의 맥락을 바탕으로<br />상태를 점검하고 다음 작업을 준비합니다.</p>
          <div class="agent-suggestions">
            <button (click)="prompt='현재 인프라 상태를 요약해 줘'">
              <wiz-icon name="activity"></wiz-icon>현재 인프라 상태 요약하기
            </button>
            <button (click)="prompt='서비스 배포 전 확인할 사항을 알려 줘'">
              <wiz-icon name="play"></wiz-icon>서비스 배포 준비하기
            </button>
            <button (click)="prompt='최근 실패한 작업을 분석해 줘'">
              <wiz-icon name="eye"></wiz-icon>실패한 작업 살펴보기
            </button>
          </div>
          <p class="small-note" *ngIf="agentStatus()['enabled']===false">
            Agent 연결이 설정되지 않았습니다.<br />시스템에서 실행 환경을 확인해 주세요.
          </p>
        </div>
        <ng-container *ngIf="activeJob() as job">
          <div class="agent-job agent-job-heading">
            <strong>{{ job['title'] }}</strong>
            <span class="badge" [ngClass]="tone(job['status'])">{{ status(job['status']) }}</span>
          </div>
          <div class="agent-timing" *ngIf="job['createdAt']">
            <span>질문 <time [attr.datetime]="job['createdAt']">{{ messageTime(job['createdAt']) }}</time></span>
            <span *ngIf="elapsed(job)">{{ agentRunning() ? '현재' : '총' }} 걸린 시간 {{ elapsed(job) }}</span>
          </div>
          <div class="agent-message" [class.user]="message['role']==='user'" *ngFor="let message of activeMessages()">
            <div class="agent-message-meta"><span class="agent-message-role">{{ message['role']==='user' ? '나' : 'Agent' }}</span><time *ngIf="message['timestamp']" [attr.datetime]="message['timestamp']">{{ messageTime(message['timestamp']) }}</time></div>
            <div class="agent-markdown" [innerHTML]="message['html']"></div>
          </div>
          <ng-container *ngFor="let request of job['interactions'] || []" [ngTemplateOutlet]="interactionCard" [ngTemplateOutletContext]="{ $implicit: request }"></ng-container>
          <div class="agent-job" *ngFor="let action of job['actions'] || []">
            <strong>{{ action['action'] }}</strong>
            <p class="small-note">{{ action['impact'] }}</p>
            <button class="button small" (click)="reviewAction(action)" [disabled]="action['approved']">
              <wiz-icon name="check"></wiz-icon>{{ action['approved'] ? '승인됨' : '대상과 영향 검토' }}
            </button>
          </div>
        </ng-container>
        <div class="notice" *ngIf="resumeSession">
          이전 대화를 이어갑니다.
          <button class="text-link" (click)="newChat()"><wiz-icon name="plus"></wiz-icon>새 대화</button>
        </div>
      <div *ngIf="selectedAction() as action" class="agent-job">
        <h3>실행 계획 확인</h3>
        <dl class="definition-list">
          <div>
            <dt>대상</dt>
            <dd>{{ action['targetId'] }}</dd>
          </div>
          <div>
            <dt>영향</dt>
            <dd>{{ action['impact'] }}</dd>
          </div>
          <div>
            <dt>복구</dt>
            <dd>{{ action['recovery'] }}</dd>
          </div>
        </dl>
        <label class="field" style="margin-top: 16px"
          ><span class="checkbox-label"
            ><input type="checkbox" [(ngModel)]="approvalChecked" />대상과 영향,
            복구 방법을 확인했습니다.</span
          ></label
        >
        <div class="toolbar-right">
          <button class="button small" (click)="selectedAction.set(null)">
            <wiz-icon name="close"></wiz-icon>닫기</button
          ><button
            class="button primary small"
            [disabled]="!approvalChecked || agentLoading()"
            (click)="approveAction()"
          >
            <wiz-icon name="check"></wiz-icon>승인하고 실행
          </button>
        </div>
      </div>
      </ng-container>
      <ng-container *ngIf="agentTab==='history'">
        <ng-container *ngIf="!historySelection()">
          <div class="agent-history-search">
            <label class="search-field">
              <wiz-icon name="search"></wiz-icon>
              <input [(ngModel)]="historyQuery" placeholder="이전 대화 검색" (keyup.enter)="historyPage=1;history()" aria-label="대화 검색" />
            </label>
            <div class="agent-history-filters">
              <input class="filter-select" type="date" [(ngModel)]="historyDate" aria-label="대화 날짜" />
              <button class="button small" (click)="historyPage=1;history()" [disabled]="agentLoading()">
                <wiz-icon name="search"></wiz-icon>조회하기
              </button>
            </div>
          </div>
          <div class="agent-job agent-history-entry" *ngFor="let session of historySessions()">
            <button type="button" (click)="selectHistory(session)" [disabled]="agentLoading()">
              <wiz-icon name="history"></wiz-icon>
              <span>{{ session['title'] || '이전 대화' }}<small class="muted">{{ date(session['updatedAt']) }}</small></span>
              <wiz-icon name="chevron"></wiz-icon>
            </button>
          </div>
          <div class="empty-state" *ngIf="!historySessions().length && !agentLoading()">
            <span class="empty-icon"><wiz-icon name="history"></wiz-icon></span>
            <h3>아직 대화 기록이 없습니다</h3>
            <p>새로운 대화를 시작하면 여기에 표시됩니다.</p>
          </div>
          <div class="toolbar-right">
            <button class="button small" [disabled]="historyPage===1 || agentLoading()" (click)="historyPage=historyPage-1;history()">
              <wiz-icon name="back"></wiz-icon>이전
            </button>
            <span class="count-label">{{ historyPage }}</span>
            <button class="button small" [disabled]="historySessions().length<20 || agentLoading()" (click)="historyPage=historyPage+1;history()">
              <wiz-icon name="arrow"></wiz-icon>다음
            </button>
          </div>
        </ng-container>
        <section class="agent-history-detail" *ngIf="historySelection() as session" aria-label="이전 대화 내용">
          <button class="text-link" type="button" (click)="historySelection.set(null)">
            <wiz-icon name="back"></wiz-icon>목록으로
          </button>
          <h3>{{ session['title'] || '이전 대화' }}</h3>
          <p class="small-note">{{ date(session['updatedAt']) }}</p>
          <div class="agent-timing" *ngFor="let timing of session['timings'] || []">
            <span>질문 <time [attr.datetime]="timing['createdAt']">{{ messageTime(timing['createdAt']) }}</time></span>
            <span *ngIf="elapsed(timing)">{{ timing['finishedAt'] ? '총' : '현재' }} 걸린 시간 {{ elapsed(timing) }}</span>
          </div>
          <div class="agent-message" [class.user]="message['role']==='user'" *ngFor="let message of historyMessages()">
            <div class="agent-message-meta"><span class="agent-message-role">{{ message['role']==='user' ? '나' : 'Agent' }}</span><time *ngIf="message['timestamp']" [attr.datetime]="message['timestamp']">{{ messageTime(message['timestamp']) }}</time></div>
            <div class="agent-markdown" [innerHTML]="message['html']"></div>
          </div>
          <ng-container *ngFor="let request of session['interactions'] || []" [ngTemplateOutlet]="interactionCard" [ngTemplateOutletContext]="{ $implicit: request }"></ng-container>
          <p class="small-note" *ngIf="!historyMessages().length && !agentLoading()">표시할 대화 내용이 없습니다.</p>
          <div class="agent-history-detail-actions">
            <button class="button small" type="button" *ngIf="session['hasMore']" [disabled]="agentLoading()" (click)="moreHistory()">대화 더 보기</button>
            <button class="button primary small" type="button" [disabled]="agentLoading()" (click)="continueHistory()">이 대화 이어가기</button>
          </div>
        </section>
      </ng-container>
    </div>
    <form class="agent-compose" *ngIf="agentTab==='chat'" (ngSubmit)="sendAgent()">
      <textarea
        id="agent-prompt"
        name="prompt"
        [(ngModel)]="prompt"
        rows="2"
        maxlength="8000"
        aria-label="Agent에게 보낼 메시지"
        placeholder="메시지를 입력하세요. Ctrl / ⌘ + Enter로 보내기"
        (keydown)="agentInputKeydown($event)"
      ></textarea>
      <button type="submit" class="button primary full" [disabled]="!prompt.trim() || agentLoading() || agentRunning() || agentStatus()['enabled']===false">
        보내기<wiz-icon name="arrow"></wiz-icon>
      </button>
    </form>
    <ng-template #interactionCard let-request>
      <section class="agent-interaction" [class.confirmation]="request['kind']==='confirmation'" [attr.aria-label]="request['title']" [attr.data-interaction-id]="request['id']">
        <div class="agent-interaction-heading"><strong>{{ request['title'] }}</strong><span class="badge">{{ interactionState(request) }}</span></div>
        <time class="small-note" [attr.datetime]="request['createdAt']">{{ messageTime(request['createdAt']) }}</time>
        <p>{{ request['message'] }}</p>
        <pre *ngIf="request['details']">{{ request['details'] }}</pre>
        <form *ngIf="request['status']==='pending'" (ngSubmit)="respondInteraction(request,'submit')">
          <fieldset *ngFor="let question of request['questions'] || []">
            <legend>{{ question['question'] }}</legend>
            <button type="button" class="agent-answer-option" *ngFor="let option of question['options'] || []" [class.selected]="answerValue(request,question['id'])===option['label']" [disabled]="replyBusy()" (click)="setAnswer(request,question['id'],option['label'])"><strong>{{ option['label'] }}</strong><small>{{ option['description'] }}</small></button>
            <label class="field"><span>{{ question['options']?.length ? '직접 입력' : '답변' }}</span>
              <input *ngIf="question['secret']" type="password" autocomplete="off" maxlength="8000" [name]="question['id']" [ngModel]="answerValue(request,question['id'])" (ngModelChange)="setAnswer(request,question['id'],$event)" [disabled]="replyBusy()" />
              <textarea *ngIf="!question['secret']" rows="2" maxlength="8000" [name]="question['id']" [ngModel]="answerValue(request,question['id'])" (ngModelChange)="setAnswer(request,question['id'],$event)" [disabled]="replyBusy()"></textarea>
            </label>
          </fieldset>
          <div class="agent-interaction-actions">
            <button type="button" class="button small" [disabled]="replyBusy()" (click)="respondInteraction(request,'reject')">취소</button>
            <button *ngIf="request['kind']==='confirmation'" type="button" class="button danger small" [disabled]="replyBusy()" (click)="respondInteraction(request,'approve')"><wiz-icon name="trash"></wiz-icon>삭제 승인</button>
            <button *ngIf="request['kind']==='question'" type="submit" class="button primary small" [disabled]="replyBusy() || !canAnswer(request)"><wiz-icon name="arrow"></wiz-icon>답변 보내기</button>
          </div>
        </form>
        <p class="small-note" *ngIf="request['answeredAt']">응답 <time [attr.datetime]="request['answeredAt']">{{ messageTime(request['answeredAt']) }}</time></p>
      </section>
    </ng-template>
  </aside>
</div>
